import React, { FC } from 'react'
import { BaseAnnotationComponentProps } from './types'
import { TextField } from './textField'

export const BaseAnnotationComp: FC<BaseAnnotationComponentProps> = ({
  content,
  align = 'start',
  lineHeight
}): JSX.Element => {
  return (
    <TextField
      text={content.toString()}
      align={align}
      lineHeight={lineHeight}
    />
  )
}
